const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/field/today.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/field/today.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { FieldLogListPendingState } from '@/features/field-log/components/FieldLogListPendingState';
import { fieldLogTodayFilters, fieldLogTodaySearchSchema } from '@/features/field-log/lib/todaySearch';
import { fieldLogVisitsQuery } from '@/features/field-log/services/fieldLogQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/field/today')({
  validateSearch: fieldLogTodaySearchSchema,
  loaderDeps: ({
    search
  }) => search,
  loader: ({
    context,
    deps
  }) => context.queryClient.ensureInfiniteQueryData(fieldLogVisitsQuery(fieldLogTodayFilters(context.authUid, deps))),
  pendingComponent: FieldLogListPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});